import { render, staticRenderFns } from "./UnifiedBar.vue?vue&type=template&id=64419959&scoped=true"
import script from "./UnifiedBar.vue?vue&type=script&lang=ts"
export * from "./UnifiedBar.vue?vue&type=script&lang=ts"
import style0 from "./UnifiedBar.vue?vue&type=style&index=0&id=64419959&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64419959",
  null
  
)

export default component.exports